<template lang="pug">
  router-view
</template>

<script>
export default {
  name: "app",
  computed: {
    user() {
      return this.$store.state.user;
    }
  },
  watch: {
    user(val) {
      if (val) this.$router.push({ name: "Wall" });
      else this.$router.push({ name: "Login" });
    }
  },
  created() {
    this.$store.dispatch("initAuthAction");
  }
};
</script>
